export default {
  path: '/auth',
  component: () => import('@/views/auth/Auth.vue'),
  children: [
    {
      path: '',
      name: 'AuthPage',
      redirect: { name: 'LoginPage' }
    },
    {
      path: 'login',
      name: 'LoginPage',
      component: () => import('@/views/auth/pages/Login.vue'),
      meta: {
        layout: 'blank'
      }
    },
    {
      path: 'forget-password',
      name: 'ForgetPassword',
      component: () => import('@/views/auth/pages/ForgetPassword.vue'),
      meta: {
        layout: 'blank'
      }
    },
    {
      path: 'new-password',
      name: 'NewPassword',
      component: () => import('@/views/auth/pages/NewPassword.vue'),
      meta: {
        layout: 'blank'
      }
    },
    {
      path: 'register',
      name: 'Register',
      component: () => import('@/views/auth/pages/Register.vue'),
      meta: {
        layout: 'blank'
      }
    },
    {
      path: 'logout',
      name: 'LogoutPage',
      component: () => import('@/views/auth/pages/Logout.vue'),
      meta: {
        layout: 'blank'
      }
    },
    {
      path: 'clinic-logout',
      name: 'ClinicLogout',
      component: () => import('@/views/auth/pages/ClinicLogout.vue'),
      meta: {
        layout: 'blank'
      }
    },
    {
      path: 'create-clinic/:id',
      name: 'CreateClinic',
      component: () => import('@/views/auth/pages/CreateClinic.vue'),
      meta: {
        layout: 'blank'
      }
    },
    {
      path: 'choose-clinic',
      name: 'ChooseClinic',
      component: () => import('@/views/auth/pages/ChooseClinic.vue'),
      meta: {
        layout: 'blank',
        meta: {
          auth: true
        }
      }
    },
    {
      path: 'verify-clinic',
      name: 'VerifyCreateClinic',
      component: () => import('@/views/auth/pages/VerifyCreateClinic.vue'),
      meta: {
        layout: 'blank'
      }
    },
    {
      path: 'verify-user',
      name: 'VerifyAddUser',
      component: () => import('@/views/auth/pages/VerifyAddUser.vue'),
      meta: {
        layout: 'blank'
      }
    },
    {
      path: '*',
      name: 'Auth404Page',
      redirect: { name: 'LoginPage' }
    }
  ]
}
